import React, { FunctionComponent } from 'react';
import Slider from 'react-slick';
import { useIsMobile } from '../../../hooks/useIsMobile';
import type { Props } from './types';

const mobileSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: true,
  centerMode: true,
  centerPadding: '10%',
  dots: true,
  draggable: true,
  swipe: true,
};

export const Presentation: FunctionComponent<Props> = ({ tvs }) => {
  const isMobile = useIsMobile();

  const items = tvs.map((tv, i) => (
    <div
      key={tv.id}
      className="sitetop-recruitment-container-link gtm-tv-view-count"
      data-event-name="tv on screen"
      data-category="topcontent"
      data-value={i < 3 ? `tv${i + 1}` : 'tv'}
      data-tyid={tv.id}
      data-companyid={tv.companyId}
    >
      <div className="sitetop-recruitment-container-box">
        <div className="sitetop-recruitment-container-box-inner">
          <a
            href={`/tvs/${tv.id}`}
            data-event="click"
            data-category="topcontent"
            data-value={i < 3 ? `tv${i + 1}` : 'tv'}
            data-click-point="image"
            data-tvid={tv.id}
            data-companyid={tv.companyId}
          >
            <div
              style={{
                background: `url(${tv.thumbnail}) no-repeat center center`,
                backgroundSize: 'cover',
              }}
              className="sitetop-recruitment-container-box-tvimg"
            />
          </a>
          <div className="sitetop-recruitment-container-box-inner-bottom">
            <a
              href={`/tvs/${tv.id}`}
              data-event="click"
              data-category="topcontent"
              data-value={i < 3 ? `tv${i + 1}` : 'tv'}
              data-click-point="title"
              data-tvid={tv.id}
              data-companyid={tv.companyId}
            >
              <div className="sitetop-recruitment-container-box-title">{tv.title}</div>
              <div className="sitetop-recruitment-container-box-occupation">
                <span className="sitetop-recruitment-container-box-occupation-word">
                  {tv.updatedAt}
                </span>
              </div>
            </a>
            <div className="sitetop-recruitment-container-box-company">
              <a
                href={`/companies/${tv.companyId}`}
                data-event="click"
                data-category="topcontent"
                data-value={i < 3 ? `tv${i + 1}` : 'tv'}
                data-click-point="company"
                data-tvid={tv.id}
                data-companyid={tv.companyId}
              >
                <span className="sitetop-recruitment-container-box-company-icon">
                  <img
                    src={tv.companyIcon}
                    alt={tv.companyName ? `${tv.companyName}のロゴ写真` : 'アイコン画像'}
                    className="sitetop-recruitment-container-box-company-icon-img"
                  />
                </span>
              </a>
              <a
                href={`/companies/${tv.companyId}`}
                className="sitetop-recruitment-container-box-company-name"
                data-event="click"
                data-category="topcontent"
                data-value={i < 3 ? `tv${i + 1}` : 'tv'}
                data-click-point="company"
                data-tvid={tv.id}
                data-companyid={tv.companyId}
              >
                {tv.companyName}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <section className="sitetop-recruitment" id="tvs">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          TV<span className="sitetop-pickup-sub">企業説明会をチェック</span>
        </h2>
        <a
          href="/tvs"
          className="sitetop-pickup-companies gtm-button-view-count"
          data-event-name="button on screen"
          data-event="click"
          data-category="topcontent"
          data-value="tv_to_all"
        >
          TV一覧へ
        </a>
      </div>
      <div className="sitetop-recruitment-container">
        {isMobile ? (
          <Slider {...mobileSettings} className="sitetop-recruitment-container-inner">
            {items}
          </Slider>
        ) : (
          items
        )}
      </div>
      <a
        href="/tvs"
        className="sitetop-pickup-spcompanies gtm-button-view-count"
        data-event="click"
        data-category="topcontent"
        data-value="tv_to_all"
      >
        TV一覧へ
      </a>
    </section>
  );
};
